// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/chevron-down.svg';

export const ChevronDown = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
